/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'gift': {
    width: 21,
    height: 20,
    viewBox: '0 0 21 20',
    data: '<path pid="0" d="M5.671 2.071a2.742 2.742 0 00-1.936 3.354c.083.31.225.587.398.838L.445 7.25l1.417 5.29.882-.236 1.674 6.248a1.746 1.746 0 002.138 1.235l12.497-3.35a1.747 1.747 0 001.235-2.137l-1.675-6.249.882-.236-1.418-5.29-3.688.989a2.703 2.703 0 00-.074-.925A2.741 2.741 0 0010.96.654a2.718 2.718 0 00-1.58 1.16L9.38 1.8l-.05.087a2.742 2.742 0 00-.051.088l-.545.943-.943-.545a2.752 2.752 0 00-.087-.05l-.088-.05.004.012A2.718 2.718 0 005.67 2.07zm.473 1.763a.914.914 0 01.472 1.763.914.914 0 01-.472-1.763zm5.29-1.417a.914.914 0 01.472 1.763.914.914 0 01-.473-1.763zM2.68 8.542l14.106-3.78.472 1.763-14.106 3.78-.472-1.763zm1.826 3.29l5.29-1.417 1.653 6.171-5.29 1.418-1.653-6.172zm7.053-1.89l5.29-1.417 1.653 6.171-5.29 1.418-1.653-6.172z" _fill="#646769"/>'
  }
})
